/**
 * Where the link in a customer SMS points. Decides both the URL and the teaser
 * wording, and is the only thing that differs between the places a mechanic can
 * compose an SMS.
 *
 * Not persisted — SmsDeliveryMode records what the customer actually got. This
 * is only an input to composing the message.
 */
export enum SmsTarget {
  CHAT = "CHAT",
  SERVICE_PROPOSAL = "SERVICE_PROPOSAL",
  /**
   * Points at the same page as SERVICE_PROPOSAL, but the teaser says the
   * proposal is waiting for an answer rather than announcing a new one.
   */
  SERVICE_PROPOSAL_REMINDER = "SERVICE_PROPOSAL_REMINDER",
  ADDON_ORDER = "ADDON_ORDER",
  /**
   * Points at the same page as ADDON_ORDER, but the teaser says the addon
   * order is waiting for an answer. Used for a service proposal reminder sent
   * to a customer whose pending answer is an addon order.
   */
  ADDON_ORDER_REMINDER = "ADDON_ORDER_REMINDER",
  /**
   * Points at the chat, but the teaser says the bike is ready to be picked up.
   * Only sent automatically when a job becomes Färdig.
   */
  PICKUP_READY = "PICKUP_READY",
  /** Points at the chat; the teaser reminds the customer to pick up the bike. */
  PICKUP_REMINDER = "PICKUP_REMINDER",
}
